import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ApiService } from '@/shared/services/api.service';
import { singlesiteSelectionDropdownConfig } from '@/shared/constants/site-selection-dropdown';
import { OPEN_SITE_SELECTION_SHORTCUT_KEYS, ShortcutCode, ShortcutKey } from '@/cpm/shared/constants/keyboard-shortcut.constants';
import { SiteSelectionDropdownComponent } from '@/cpm/shared/standalone-components/site-selection-dropdown/site-selection-dropdown.component';

@Component({
  selector: 'app-edit-plant-modal',
  templateUrl: './edit-plant-modal.component.html',
  styleUrls: ['./edit-plant-modal.component.scss'],
  standalone: false
})
export class EditPlantModalComponent implements OnInit, OnDestroy {
  readonly OPEN_SITE_SELECTION_SHORTCUT_KEYS = OPEN_SITE_SELECTION_SHORTCUT_KEYS;
  plantName: any;
  selectedSite = [];
  @ViewChild('buildingListRef') buildingRef: SiteSelectionDropdownComponent;
  @ViewChild('plantNameInput') plantNameInput: ElementRef;
  errorText: any = "";
  sitePlaceHolderText: any;
  siteSelectionConfig = singlesiteSelectionDropdownConfig;
  selectedSiteId: string = '';
  // Capture Escape at the document level so we can close dropdown first, then modal.
  private readonly escCaptureHandler = (event: KeyboardEvent): void => this.onEscapeKeydown(event);

  constructor(@Inject(DIALOG_DATA) public data,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EditPlantModalComponent>,
    public apiService: ApiService,) { }

  ngOnInit(): void {
    // Keep Material from auto-closing; modal close is controlled explicitly in onEscapeKeydown().
    this.dialogRef.disableClose = true;
    // Capture phase ensures this runs before bubbling handlers.
    document.addEventListener('keydown', this.escCaptureHandler, true);
    if (this.data.type == "edit") {
      this.data.plantName = this.data.plantData.chillerPlantName;
      this.data.building.filter((building) => {
        if (this.data.plantData.siteId == building.id) {
          this.selectedSite.push(building);
          this.selectedSiteId = building.id;
          this.sitePlaceHolderText = this.selectedSite[0].dis;
        }
      });
    } else {
      this.sitePlaceHolderText = "Select Building";
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.plantNameInput?.nativeElement?.focus();
    });
  }

  // Handle Escape key press to close dropdown or modal.
  onEscapeKeydown(event: KeyboardEvent): void {
    if (event.key !== ShortcutKey.ESCAPE && event.code !== ShortcutCode.ESCAPE) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    // If dropdown is open, consume Escape to close only the dropdown.
    if (this.buildingRef?.isOpen?.()) {
      this.buildingRef.closeDropdown();
      return;
    }

    // If dropdown is already closed, close the modal.
    this.cancel();
  }

  cancel() {
    this.dialogRef.close('cancel');
  }

  buildingSelected(site) {
    if (site) {
      this.selectedSite = [site];
      this.selectedSiteId = site?.id ?? '';
    }
  }

  save() {
    if (this.data.type == 'add') {
      let plantData = {
        chillerPlantName: this.data.plantName.trim(),
        orgId: this.data.seletedOrg.orgId,
        orgName: this.data.seletedOrg.orgName,
        siteId: this.selectedSite[0].id
      }
      this.errorText = "";
      this.apiService
        .addPlant(plantData)
        .subscribe((_res) => {
          this.dialogRef.close(_res);
        },
          (err) => {
            this.errorText = err.error.error;
          });
    } else if (this.data.type == 'edit') {
      let plantData = {
        chillerPlantName: this.data.plantName.trim(),
        siteId: this.selectedSite[0].id
      }
      this.errorText = "";
      this.apiService
        .editPlant(this.data.plantData.chillerPlantId, this.data.seletedOrg.orgName, plantData)
        .subscribe((_res) => {
          this.dialogRef.close(_res);
        },
          (err) => {
            this.errorText = err.error.error;
          });
    }
  }

  // Remove global listener to avoid leaks after modal closes.
  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.escCaptureHandler, true);
  }
}
